export const detectRusSymbols = (text: string) => (/\p{sc=Cyrillic}/giu).test(text);
